import { render, staticRenderFns } from "./GptDatasets.vue?vue&type=template&id=7778d204"
import script from "./GptDatasets.vue?vue&type=script&lang=js"
export * from "./GptDatasets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports